import { Link } from "react-router-dom"
import { Phone } from "lucide-react"

export default function Header() {
  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-muted">
      <div className="max-w-3xl mx-auto flex items-center justify-between px-4 h-16 lg:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <picture>
            <source srcSet="/images/logo.webp" type="image/webp" />
            <img
              src="/images/logo.png"
              alt="Skyline Roofing & Exteriors"
              width={119}
              height={64}
              className="h-12 lg:h-14 w-auto"
            />
          </picture>
        </Link>

        {/* Phone CTA */}
        <a
          href="tel:+15138989000"
          className="flex items-center gap-2 text-sm font-bold text-primary hover:text-primary-dark transition-colors"
        >
          <Phone className="w-4 h-4" />
          <span className="hidden sm:inline">(513) 898-9000</span>
        </a>
      </div>
    </header>
  )
}
